<template>
  <section class="carousel">
    <el-carousel height="550px" :interval="4000">
      <el-carousel-item class="carouselItem" v-for="(item, index) in imgList" :key="index">
        <img class="img" :src="item.carouselSrc" @click="goNewsDetail(item)" alt="" />
      </el-carousel-item>
    </el-carousel>
  </section>
</template>

<script>
import { LESSONS_DATA } from '../utils/LingXunData'
export default {
  name: 'LayoutCarousel',
  data () {
    return {
      imgList: LESSONS_DATA.slice(0, 3)
    }
  },
  methods: {
    goNewsDetail (item) {
      localStorage.setItem('NEWS_DETAIL', JSON.stringify(item))
      // this.$router.push({
      //   path: `/newsDetail/${item.id}`,
      //   params: item
      // })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .carousel{
    height: 550px;
    width: 100%;
    margin: 0 auto;
    .carouselItem{
      display: flex;
      align-items: center;
      justify-content: center;
      .img{
        display: block;
        width: 1920px;
        height: 550px;
        object-fit: cover;
        object-position: top;
        cursor: pointer;
      }
    }
  }
</style>
